// English strings for the LDAP / Active Directory directory stream (PB-17-07, PB-03-09;
// PD-590 – PD-597). Arabic: ar-ldap.ts.
export const enLdap = {
  'status.unknown': 'Unknown',

  // ------------------------------------------------------------ validation
  'ldap.v.plaintext': 'Use ldaps://, or ldap:// with StartTLS. Unencrypted LDAP is allowed only to this computer during development.',
  'ldap.v.tlsBoth': 'StartTLS is for ldap:// addresses; ldaps:// is already encrypted.',
  'ldap.v.filter': 'Not a valid LDAP search filter.',
  'ldap.v.attribute': 'Enter an LDAP attribute name (letters, digits and hyphens) or an OID.',
  'ldap.v.pem': 'Paste the CA certificate in PEM format (BEGIN CERTIFICATE … END CERTIFICATE).',
  'ldap.v.oneSecret': 'Enter a bind password or a deployment secret name, not both.',

  // ------------------------------------------------------------ run outcomes and errors
  'directory.unknown': 'The directory did not answer in time. Nothing changed; the outcome is unknown until the next successful read.',
  'directory.error.invalid_configuration': 'The connection settings are not valid',
  'directory.error.transport_insecure': 'Unencrypted connection refused',
  'directory.error.tls_failed': 'Secure connection failed (certificate or TLS)',
  'directory.error.bind_failed': 'The bind account was refused (check the DN and password)',
  'directory.error.search_failed': 'The search was refused (check the search base, filter and permissions)',
  'directory.error.size_limit': 'More entries than the configured limit; nothing was applied',
  'directory.error.timeout': 'The directory did not answer in time (outcome unknown)',

  // ------------------------------------------------------------ connection facts
  'ldap.facts': 'Connection',
  'ldap.f.url': 'Endpoint',
  'ldap.f.urlHint': 'ldaps://host:636, or ldap://host:389 with StartTLS.',
  'ldap.f.startTls': 'Upgrade with StartTLS before signing in',
  'ldap.f.caCertificate': 'Directory CA certificate (optional, PEM)',
  'ldap.f.caCertificateHint': 'Only for a private certificate authority. Certificates are always verified.',
  'ldap.f.bindDn': 'Bind account (DN)',
  'ldap.f.bindPassword': 'Bind password',
  'ldap.f.bindPasswordHint': 'Stored encrypted and never shown again. Leave empty to use a deployment secret name instead.',
  'ldap.f.searchBase': 'Search base (DN)',
  'ldap.f.scope': 'Search scope',
  'ldap.scope.sub': 'Whole subtree',
  'ldap.scope.one': 'One level',
  'ldap.f.filter': 'User filter',
  'ldap.mapping': 'Attribute mapping',
  'ldap.mappingHint': 'Only the attributes named here are read. Leave an optional attribute empty to not read it. Host sync then uses the same attribute names.',
  'ldap.f.attr.externalId': 'Immutable ID',
  'ldap.f.attr.email': 'Email',
  'ldap.f.attr.displayName': 'Display name',
  'ldap.f.attr.employeeId': 'Employee ID (optional)',
  'ldap.f.attr.department': 'Department (optional)',
  'ldap.f.attr.title': 'Job title (optional)',
  'ldap.f.attr.office': 'Office site code (optional)',
  'ldap.f.enabledMode': 'Disabled accounts',
  'ldap.enabled.ad_user_account_control': 'Active Directory userAccountControl (disabled flag)',
  'ldap.enabled.attribute': 'An attribute value',
  'ldap.enabled.none': 'Not read (leavers are found when they leave the search scope)',
  'ldap.f.enabledAttribute': 'Attribute',
  'ldap.f.disabledValues': 'Values meaning disabled (comma-separated; empty = attribute present)',
  'ldap.f.pageSize': 'Page size',
  'ldap.f.timeoutMs': 'Timeout per request (ms)',
  'ldap.transport.ldaps': 'LDAPS',
  'ldap.transport.starttls': 'StartTLS',
  'ldap.transport.plain': 'Unencrypted (development only)',
  'ldap.secret.sealed': 'Stored encrypted (version {version}, {at})',
  'ldap.secret.reference': 'Deployment secret {name}',
  'ldap.secret.none': 'Not set',
  'ldap.secret.label': 'Bind credential',
  'ldap.edit': 'Edit connection',
  'ldap.editSub': 'Changes apply from the next test or synchronisation. The bind password is changed separately.',
  'ldap.setPassword': 'Set bind password',
  'ldap.setPasswordSub': 'The password is encrypted at rest, never shown, logged or audited, and replaces any deployment secret name.',

  // ------------------------------------------------------------ test connection (counts only)
  'ldap.test': 'Test connection',
  'ldap.testing': 'Testing…',
  'ldap.test.lastLabel': 'Last test',
  'ldap.test.ok': 'Signed in and searched: {sampled} sample entries read.',
  'ldap.test.counts': 'With ID {withExternalId} · with email {withEmail} · with display name {withDisplayName} · disabled {disabled}',
  'ldap.test.mapped': '{attribute}: {count} of {sampled}',
  'ldap.test.failed': 'Test failed: {reason}',
  'ldap.test.unknown': 'The directory did not answer in time: the result is unknown.',
  'ldap.test.privacy': 'Only counts are shown; no names, emails or identifiers are read back.',
} as const;
